import styled from 'styled-components'
import { InputModes } from '.'
import { iPadDown } from '../../styles/mediaQueries'
import globalTheme from '../../styles/theme'
import { DolaThemes } from '../../styles/types'
import {
  borderRadius,
  borderWidth,
  desktopFontSize,
  fontSize,
  mobileFontSize,
} from '../../styles/variables'
import theme from './theme'

export interface InputBaseStyleProps {
  dolaTheme: DolaThemes
  mode: InputModes
}

export const FauxInput = styled.div<InputBaseStyleProps>`
  background-color: ${({ dolaTheme, mode }) =>
    theme[dolaTheme][mode].background};
  border-color: ${({ dolaTheme, mode }) => theme[dolaTheme][mode].border};
  box-shadow: none;
  border-style: solid;
  color: ${({ dolaTheme, mode }) => theme[dolaTheme][mode].text};
  height: 3.13vw;
  padding: 0 1.17vw;
  position: relative;
  outline: none;
  width: 100%;
  ${borderRadius};
  ${borderWidth};
  ${fontSize};

  ${iPadDown} {
    height: 9.7vw;
    padding: 0 4.1vw;
  }

  label {
    left: -0.16vw;

    ${iPadDown} {
      left: -0.4vw;
    }
  }
`

export const Input = styled.input<InputBaseStyleProps>`
  background-color: transparent;
  border: none;
  box-shadow: none;
  caret-color: ${({ dolaTheme }) => globalTheme[dolaTheme].text};
  display: block;
  flex-grow: 1;
  padding: 0;
  position: relative;
  -webkit-text-fill-color: ${({ dolaTheme, mode }) =>
    theme[dolaTheme][mode].text};
  width: 100%;
  ${fontSize};
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    box-shadow: none;
    -webkit-box-shadow: inset 0 0 0px 1000px
      ${({ dolaTheme, mode }) => theme[dolaTheme][mode].background};
  }
`

export const InputWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
`

export const Error = styled.div<InputBaseStyleProps>`
  align-items: center;
  display: flex;
  margin-top: 0.5vw;

  ${iPadDown} {
    margin-top: 1.55vw;
  }

  p {
    line-height: 1.5;
  }
`

interface LabelProps extends InputBaseStyleProps {
  toBorder: boolean
}

export const Label = styled.label<LabelProps>`
  color: ${({ dolaTheme, mode }) => theme[dolaTheme][mode].label};
  height: 100%;
  max-height: ${({ toBorder }) => (toBorder ? '1vw' : '100px')};
  display: flex;
  font-size: ${({ toBorder }) => (toBorder ? '0.8vw' : desktopFontSize)};
  font-weight: normal;
  align-items: center;
  padding: 0 ${({ toBorder }) => (toBorder ? '0.32vw' : '1.17vw')};
  position: absolute;
  transition: all 0.2s ease;
  ${({ toBorder, dolaTheme, mode }) =>
    toBorder
      ? `
    background: ${theme[dolaTheme][mode].background};
    margin: 0 1vw;
    top: -0.5vw;
  `
      : ''}

  ${iPadDown} {
    font-size: ${({ toBorder }) => (toBorder ? '3vw' : mobileFontSize)};
    padding: 0 ${({ toBorder }) => (toBorder ? '1vw' : '4.1vw')};
    ${({ toBorder }) =>
      toBorder
        ? `
    max-height: 3vw;
    margin: 0 3.75vw;
    top: -1.25vw;
  `
        : ''}
  }
`

export const Mask = styled.div`
  color: #dddddd;
`
